import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProgramsTestimonials.scss';

const ProgramsTestimonials = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: 1,
      title: 'Programmes',
      headerImage: '/assets/IMG/programmes.png',
      hasSharedContent: true,
      link: '/programmes'
    },
    {
      id: 2,
      title: 'Témoignages',
      headerImage: '/assets/IMG/temoignage.png',
      hasSharedContent: true,
      link: '/partenaires'
    },
    {
      id: 3,
      title: 'Qui sommes nous',
      headerImage: '/assets/IMG/nous.png',
      link: '/presentation',
      texts: [
        'Comment agit la Fondation ?',
        'Comment est financée la Fondation ?',
        'Qui est à la tête de la Fondation ?',
        'Faut-il être ivoirien pour être membre ?',
        'Combien coûte l\'adhésion à un programme ?',
        'Comment faire un don ?',
        'Est-ce que la Fondation me trouve un stage ?',
        'Comment être partenaire de la Fondation ?'
      ]
    }
  ];

  return (
    <section className="programs-testimonials">
      <div className="programs-testimonials-container">
        <div className="cards-grid">
          {/* En-têtes des 3 cards */}
          <div className="cards-headers">
            {cards.map((card) => (
              <div
                key={card.id}
                className="card-wrapper"
                onClick={() => navigate(card.link)}
                style={{ cursor: 'pointer' }}
              >
                <h2 className="card-main-title">{card.title}</h2>
                <div className="card-header-wrapper">
                  <div className="card-header">
                    <img src={card.headerImage} alt={card.title} className="header-image" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contenus */}
          <div className="cards-contents">
            {/* Zone fusionnée pour Programmes et Témoignages */}
            <div className="merged-content">
              <img src="/assets/IMG/brochure.jpg" alt="Brochure" className="brochure-image" />
            </div>

            {/* Contenu de Qui sommes nous */}
            <div className="card-body">
              <h3 className="card-title">Qui sommes nous</h3>
              <div className="card-texts">
                {cards[2].texts.map((text, idx) => (
                  <p key={idx}>{text}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsTestimonials;
